<template>
  <div
    class="btn-scroll-to-top"
    :class="{ show: y > 250 }"
  >
    <b-button
      variant="primary"
      class="btn-icon"
      @click="scrollToTop"
    >
      <b-icon-arrow-up />
    </b-button>
  </div>
</template>

<script>
import { useWindowScroll } from '@vueuse/core'
import { BButton, BIconArrowUp } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BIconArrowUp,
  },
  setup() {
    const { y } = useWindowScroll()

    const scrollToTop = () => {
      const rootEle = document.documentElement
      rootEle.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }

    return { y, scrollToTop }
  },
}
</script>

<style lang="scss" scoped>
.btn-scroll-to-top {
  position: fixed;
  bottom: 100px;
  right: 0px;
  z-index: 99;
  opacity: 0;
  transform: translateX(100px);
  transition: all 0.5s ease;

  &.show {
    opacity: 1;
    transform: translateX(0);
  }
  button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 23px 10px;
  }
}
</style>
